import { ConfigProvider, Flex, Row, Upload, UploadProps, message } from "antd"
import styles from "./DocumentUpload.module.scss"
import Icon from "../../components/icon/Icon"
import { CSSProperties, PropsWithChildren, createContext, useContext, useEffect, useState } from "react"
import { FormContext, FormItemContext } from "../../components/form/FormContext"
import Env from "../../../Env"
import uploadSvg from "../assets/images/upload-cloud-02.svg"
import { DraggerProps } from "antd/es/upload"
import axios from "axios"
import fileSvg from "../assets/images/file-04.svg"
import trashSvg from "../assets/images/trash-01.svg"
import { format } from "../../libs/bytes"
import checkSvg from "../assets/images/check.svg"
import fileUploadedSvg from "../assets/images/file-04-uploaded.svg"
import fileReadOnlySvg from "../assets/images/file-04-readonly.svg"
import { toHumanDateTime } from "../../libs/datetime"
import OssApi from "../../api/Oss.api"
import documentApi from "../../api/document.api"
import { useTranslate } from "../../components/language"


interface UploadingFile{
    precent: number
    filename: string
    size: string
    status: "done"|"uploading"|""
    updated_at?: string
}

export default (props: {readonly?: boolean}) => {

    const {
        Dragger
    } = Upload

    const {name} = useContext(FormItemContext)
    const {values, setValues} = useContext(FormContext)
    const [fileId, setFileId] = useState<string>()
    const [uploadingFile, setUploadingFile] = useState<UploadingFile>()
    const {t} = useTranslate()

    const customRequest: DraggerProps['customRequest'] = ({
            action,
            data,
            file,
            filename,
            headers,
            onError,
            onProgress,
            onSuccess,
            withCredentials
        }) => {

            const _file = file as File
            const name = _file.name
            const type = _file.type

            setUploadingFile({
                filename: _file.name,
                precent: 0,
                size: format(_file.size),
                status: "",
                updated_at: new Date().toISOString()
            })

            return documentApi.generatePresignedUrl({
                filename: name, 
                content_type: type
            }).then(({fields, file_key, upload_url}) => {
                const formData = new FormData()
                Object.entries(fields).forEach(([key, value]) => {
                    formData.append(key, value)
                })
                formData.append("file", _file);
                
                const config= {
                    "headers": {
                        "content-type": 'multipart/form-data;'
                    },
                }
                return axios.create({headers: {"Authorization": null}}).post(upload_url, formData, {...config, onUploadProgress: (e) => onProgress?.({...e})}).then((res: any) => {
                    Env.DEBUG && console.log("uploadSuccess: ", res)
                    onSuccess?.(file_key)
                    setFileId(file_key)

                    // onUploaded({
                    //     filename: name,
                    //     mimetype: type,
                    //     project_id,
                    //     size: _file.size,
                    //     object_key: file_key
                    // })
                }).catch((err: Error) => {
                    console.error(err)
                    onError?.(err)
                })

            }).finally(() => {
                // setLoading(false)
            })

            // return OssApi.getUploadToken({
            //     name, 
            //     content_type: type,
            //     size: _file.size
            // }).then(token => {
            //     Env.DEBUG && console.log("getToken: ", token)
            //     const {
            //         file_id,
            //         upload_args
            //     } = token
            //     const {
            //     url,
            //     fields
            //     } = upload_args
                
            //     setFileId(file_id)
            //     const formData = new FormData()
            //     Object.entries(fields).forEach(([key, value]) => {
            //         formData.append(key, value)
            //     })
            //     formData.append("file", _file);
                
            //     const config= {
            //         "headers": {
            //             "content-type": 'multipart/form-data;'
            //         },
            //     }
            //     return axios.post(url, formData, {...config, onUploadProgress: (e) => onProgress?.({...e})}).then((res: any) => {
            //         Env.DEBUG && console.log("uploadSuccess: ", res)
            //         onSuccess?.(file_id)
            //     }).catch((err: Error) => {
            //         console.error(err)
            //         onError?.(err)
            //     })

            // })
    }

    const onChange: DraggerProps['onChange'] = (uploadFile) => {
        Env.DEBUG && console.log("onChange", uploadFile)
        if(uploadFile.event){
            const percent = Math.floor(parseFloat((uploadFile.event as any)?.progress??0) * 100)
            setUploadingFile({
                filename: uploadFile.file.name as string,
                precent: Math.min(percent, 99),
                size: format(uploadFile.file.size??0),
                status: "uploading",
                updated_at: uploadingFile?.updated_at
            })
        }
        if(uploadFile.file.status == "done"){
            Env.DEBUG && console.log("onUploaded, fileId: ", uploadFile.file.response)
            setValues(name, {
                "file_id": uploadFile.file.response,
                "type": uploadFile.file.type,
                "name": uploadFile.file.name,
                "size": uploadFile.file.size,
                "updated_at":  uploadingFile?.updated_at
            })
            setUploadingFile(undefined)
            // fillingForm && fileId && FormFillingApi.updateDocument(
            //     fillingForm.case_id, 
            //     fillingForm.id, 
            //     {file_category: props.type, file_id: fileId}
            // ).then((res) => {
            //     Env.DEBUG && console.log("upload document, res: ", res)
            //     setValues(name, res)
            //     setUploadingFile(undefined)
            // })
        }
    }

    const onDelete = () => {
        // const docId = (values[name] as ProofDoc)?.id
        setValues(name, undefined)
        // Env.DEBUG && console.log("docId: ", docId, "fillingForm: ", fillingForm);
        // fillingForm && docId && FormFillingApi.deleteDocument(
        //     fillingForm.case_id,
        //     fillingForm.id,
        //     docId
        // ).then(() => {
        //     Env.DEBUG && console.log("delete document, docId: ", docId)
        // })
    }

    const beforeUpload: DraggerProps['beforeUpload'] = (file) => {
        // File extension validation
        const allowedExtensions = ['.pdf', '.png', '.jpg', '.jpeg'];
        const fileName = file.name.toLowerCase();
        const isValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));

        // MIME type validation (additional security)
        const allowedMimeTypes = [
            'application/pdf',
            'image/png',
            'image/jpeg',
            'image/jpg'
        ];
        const isValidMimeType = allowedMimeTypes.includes(file.type);

        // File size validation (10MB = 10 * 1024 * 1024 bytes)
        const maxSize = 10 * 1024 * 1024;
        const isValidSize = file.size <= maxSize;

        if (!isValidExtension) {
            message.error(t('Invalid file extension. Only PDF, PNG, and JPEG files are allowed.'));
            return Upload.LIST_IGNORE;
        }

        if (!isValidMimeType) {
            message.error(t('Invalid file type. Please upload a valid file.'));
            return Upload.LIST_IGNORE;
        }

        if (!isValidSize) {
            message.error(t('File size exceeds 10MB limit.'));
            return Upload.LIST_IGNORE;
        }

        return true;
    };

    const draggerRender = () => {
        return <ConfigProvider
                theme={{
                    token:{
                        colorFillAlter: "#fff",
                        padding: 0,
                    }
                }}
            >
                <Dragger
                    style={{border: 0}}
                    multiple={false}
                    accept=".pdf,.png,.jpg,.jpeg"
                    beforeUpload={beforeUpload}
                    customRequest={customRequest}
                    onChange={onChange}
                    showUploadList={false}
                >
                    <Flex vertical gap={12} align="center" className={styles['document_upload__dragger']}>
                        <Icon src={uploadSvg} size={40} padding={0}></Icon>
                        <Flex vertical gap={4} align="center">
                            <Flex gap={4} align="center"> 
                                <a className={styles['document_upload__dragger__a']}>{t("Click to upload")}</a>
                                {t("or drag and drop")}
                            </Flex>
                            <div className={styles['document_upload__dragger__tips']}>PDF, PNG or JPEG (max. 10mb)</div>
                        </Flex>
                    </Flex>
                </Dragger>
            </ConfigProvider>

    }

    const uploadingRender = () => {
        return (
            <div className={styles["document-upload__uploading__float"]}>
                <Flex gap={16} align="flex-start" className={styles["document-upload__uploading"]}>
                    <Icon src={fileSvg} size={28}></Icon>
                    <Flex vertical gap={4} style={{flex: 1}}>
                        <Flex vertical>
                            <Flex justify="space-between" align="center">
                                <div className={styles['document-upload__uploading__filename']}>{uploadingFile?.filename}</div>
                                <Icon src={uploadingFile?.status !== "done" ? trashSvg: checkSvg} size={20} ></Icon>
                            </Flex>
                            {/* <div className={styles['document-upload__uploading__filesize']}>{uploadingFile?.size}</div> */}
                        </Flex>
                        <Progress percent={uploadingFile?.precent??0}/>
                    </Flex>
                </Flex>
            </div>
        )        
    }

    const uploadedRender = () => {

        if(values[name]){
            const doc = values[name]
            if(doc){
                return (
                    <div className={styles["document-upload__uploaded__float"]}>
                        <Flex gap={16} align="flex-start" className={[styles["document-upload__uploaded"]].join(" ")}>
                            <Icon src={false?fileReadOnlySvg:fileUploadedSvg} size={28}></Icon>
                            <Flex gap={16} style={{flex: 1}}>
                                <Flex align="center" justify="space-between" style={{flex: 1}}>
                                    <Flex vertical>
                                        <div className={[styles['document-upload__uploaded__filename'], false?styles['document-upload__uploaded__filename_readOnly']:''].join(" ")}>{doc.name}</div>
                                        <div className={[styles['document-upload__uploaded__filesize'], false?styles['document-upload__uploaded__filesize_readOnly']:''].join(" ")}>{format(doc.size??0)}</div>
                                    </Flex>
                                    <div className={[styles['document-upload__uploaded__updatedAt'], false?styles['document-upload__uploaded__updatedAt_readOnly']:''].join(" ")}>Last update: {toHumanDateTime(doc.updated_at)}</div>
                                </Flex>
                                {
                                    false?<Icon src={trashSvg} size={20} padding={8} hoverable onClick={onDelete}></Icon>:<></>
                                }
                            </Flex>
                        </Flex>
                    </div>
                )

            }
            return <></>
        }

    }
    
    const uploaded = () => {
        if(values[name]){
            return true
        }
    }

    return (
        <div className={[styles['document-upload'], (values[name]||uploadingFile)?styles['document-upload_fill']:''].join(" ")}>
            {
                draggerRender()
            }
            {
                uploadingFile &&
                uploadingRender()
            }
            {
                uploaded() &&
                uploadedRender()
            }
        </div>
    )
    
}

const Progress = (props: {percent: number}) => {

    const style:CSSProperties = {
        maxWidth: `calc(100% * ${props.percent * 0.01})`
    }

    return (
        <Flex gap={12} className="progress" align="center">
            <div className={styles["progress__bar"]}>
                <div 
                    className={styles["progress__bar__scroller"]}
                    style={style}
                ></div>
            </div>
            <div className={styles["progress__label"]}>{props.percent}%</div>
        </Flex>
    )
}